export default "__VITE_ASSET__DLkeTMQi__"